import { Route, Switch, withRouter } from "react-router-dom";
import DashReferralSources from "@nkr/views/dash/referral-sources/dash-referral-sources";
import PageEditorPage from "@nkr/views/dash/referral-sources/page-editor-page";
import NotFound from "../not-found";

const DashReferralSourceRoutes = (params) => {
    const url = params.url;

    return (
        <Switch>
            <Route path={`${url}/referral-source/:sourceId/pages/new`} render={({ match: { params: subParams } }) => <PageEditorPage sourceId={subParams.sourceId} />} />
            <Route path={`${url}/referral-source/:sourceId/pages/:pageId`} render={({ match: { params: subParams } }) => <PageEditorPage sourceId={subParams.sourceId} pageId={subParams.pageId} />} />
            <Route exact path={`${url}/`} component={DashReferralSources} />
            <Route path={`${url}`} component={NotFound} />
        </Switch>
    );
};

export default withRouter(DashReferralSourceRoutes);
